/** @jsxImportSource @emotion/react */
import React from "react";
import { Col, InputNumber, Row, Space, Typography } from "antd";
import { Vector3 } from "../../usecases/HomeConfig/types";
import * as Styles from "./styles";

const AXES = ["x", "y", "z"] as const;

export interface Vector3InputProps {
  label: string;
  value: Vector3;
  onChange: (next: Vector3) => void;
}

export const Vector3Input = ({ label, value, onChange }: Vector3InputProps) => {
  const renderAxis = (axis: typeof AXES[number]) => {
    const handleChange = (next: number | null) => {
      onChange({ ...value, [axis]: next ?? 0 });
    };

    return (
      <InputNumber
        key={axis}
        addonBefore={axis.toUpperCase()}
        css={Styles.fieldStyle}
        value={value[axis] || 0}
        onChange={handleChange}
      />
    );
  };

  return (
    <Row gutter={8} align="middle" css={Styles.containerStyle}>
      <Col span={6}>
        <Typography.Text type="secondary">{label}</Typography.Text>
      </Col>
      <Col span={18}>
        <Space size="small">{AXES.map(renderAxis)}</Space>
      </Col>
    </Row>
  );
};
